import "./widget.scss";
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import PeopleIcon from '@mui/icons-material/People';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import { Link } from "react-router-dom";

export const Widget = ({ type }) => {
    let data;

    //temporary

   

    switch (type) {
        case "properties":
            data = {
                title: "Fleet Number",
                isMoney: false,
                link: "See all vehicles",
                route: "properties/view-properties",
                amount:3,
                icon: (
                    <DirectionsBusIcon
                        className="icon"
                        style={{
                            color: "black",
                            backgroundColor: "rgba(49, 49, 49, 0.2)",
                        }}
                    />
                )
            };
            break;
        case "tenant":
            data = {
                title: "Active Trips Today",
                isMoney: false,
                link: "View all trips",
                amount:3,
                icon: (
                    <ReceiptOutlinedIcon className="icon"
                        style={{
                            color: "black",
                            backgroundColor: "rgba(49, 49, 49, 0.2)",
                        }}
                    />
                )
            };
            break;
        case "earning":
            data = {
                title: "Today's Revenue",
                isMoney: true,
                link: "View earnings",
                amount:8000,
                icon: (
                    <MonetizationOnIcon className="icon"
                        style={{
                            color: "black",
                            backgroundColor: "rgba(49, 49, 49, 0.2)",
                        }}
                    />
                )
            };
            break;
        case "arrears":
            data = {
                title: "Number of Passengers",
                isMoney: false,
                //link: "View all overdue payments",
                amount:105,
                icon: (
                    <PeopleIcon className="icon"
                        style={{
                            color: "black",
                            backgroundColor: "rgba(49, 49, 49, 0.2)",
                        }}
                    />
                )
            };
            break;
        default:
            break;
    }

    return (
        <div className="widget">
            <div className="left">
                <span className="title">{data.title}</span>
                <span className="counter">
                    {data.isMoney && "Kes"} {data.amount}
                </span>
                <span className="link"><Link to={data.route}>{data.link}</Link></span>
            </div>
            <div className="right">
                
                {data.icon}
            </div>
        </div>
    )
}

